module.exports = __webpack_public_path__ + "images/08-03@2x_05acf4ff.png";